import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, User, Bot, CheckCircle } from 'lucide-react';
import { trackClick } from '@/utils/analytics';
import { useIsMobile } from '@/hooks/use-mobile';
interface BenefitsSectionProps {
  onFindMatch?: () => void;
}
export const BenefitsSection: React.FC<BenefitsSectionProps> = ({
  onFindMatch
}) => {
  const isMobile = useIsMobile();
  const handleFindMatchClick = () => {
    trackClick('how_it_works_find_match_button', 'secondary_cta');
    onFindMatch?.();
  };
  const steps = [{
    icon: User,
    title: "Tell us a little about yourself",
    description: "Quick 2-minute form with basic information"
  }, {
    icon: Bot,
    title: "Our AI compares all top-rated carriers",
    description: "Advanced matching across dozens of providers"
  }, {
    icon: CheckCircle,
    title: "Get your best match and quote instantly",
    description: "Personalized recommendations just for you"
  }];
  return <section className="bg-background py-[50px]">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
              How It <span className="text-primary">Works</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Get matched with the perfect life insurance policy in three simple steps
            </p>
          </div>

          {/* Steps Grid */}
          <div className={`grid ${isMobile ? 'grid-cols-1 gap-8' : 'grid-cols-1 md:grid-cols-3 gap-12'} mb-16`}>
            {steps.map((step, index) => {
            const IconComponent = step.icon;
            return <div key={index} className={`text-center ${isMobile ? 'bg-card border border-border rounded-xl p-6 shadow-sm' : ''}`}>
                  {/* Step Number & Icon */}
                  <div className="relative mb-6">
                    <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <IconComponent className="h-10 w-10 text-primary" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-bold">
                      {index + 1}
                    </div>
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-semibold text-foreground mb-3">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground">
                    {step.description}
                  </p>
                </div>;
          })}
          </div>

          {/* CTA Button */}
          {onFindMatch && <div className="text-center">
              <Button onClick={handleFindMatchClick} size="lg" variant="hero" className="h-14 px-8 text-lg font-semibold">
                Find My Best Match
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>}
        </div>
      </div>
    </section>;
};